"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var icon_1 = require("ayvri-ui/lib/icon");
var Color = require("color");
var React = require("react");
var privacy_1 = require("../icons/privacy");
var styles_1 = require("./styles");
exports.SceneActions = function (props) {
    var scene = props.scene, studioEnabled = props.studioEnabled, deleteScene = props.deleteScene, togglePrivacy = props.togglePrivacy;
    return (React.createElement("div", { className: styles_1.styles.sceneActions },
        React.createElement(StudioEditLink, null),
        React.createElement(privacy_1.PrivacyIcon, { isPrivate: !!scene.private, onTogglePrivacy: function (isPrivate) { return togglePrivacy(scene.accountId, scene.sceneId, isPrivate); } }),
        React.createElement(DeleteIcon, null)));
    function handleDeleteScene() {
        if (confirm('Are you sure you want to delete this scene?')) {
            deleteScene(scene.accountId, scene.sceneId);
        }
    }
    function StudioEditLink() {
        if (!studioEnabled) {
            return React.createElement("span", null);
        }
        return React.createElement("a", { className: styles_1.styles.studioEditLink, href: "/studio/" + scene.accountId + "/" + scene.sceneId }, "Edit in Studio");
    }
    function DeleteIcon() {
        return (React.createElement("a", { href: '#', onClick: handleDeleteScene, title: 'Delete Scene' },
            React.createElement(icon_1.Icon, { icon: 'delete', color: new Color('#c2c2c2') })));
    }
};
exports.SceneActions.displayName = 'SceneActions';
